﻿window.cBuilderEmailWidgetOuvreNavigateur = function(option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetouvrenavigateur'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>Afficher navigateur</div>").appendTo($DivBt)
        $DivBt.attr("title", "Ajouter un lien permettant de visualiser votre message dans un navigateur")
        return $DivBt
    }

    this.mCreateElement = function () {
        option.element = $("<tr class='widget dxwidgetouvrenavigateur'>")
        $("<!-- DEBUT LIEN AFFICHAGE NAVIGATEUR -->").appendTo(option.element)
        var $Td = $("<td valign='top' style='word-break:break-word;with:100%;' width='100%' class='bodywidget tdwidget widgetheightauto'></td>").appendTo(option.element)
        var jsonDuplik = JSON.parse(JSON.stringify(option.dxBuilderEmailPage.mJsonCssGuideProperty("lienouvrirnavigateur")))
        for (var prop in jsonDuplik) jsonDuplik[prop] = ""
        $Td.attr("jsoncssdatawidget", JSON.stringify(jsonDuplik))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'></td>").appendTo($Tr)
        $("<a href='https://lien_ouvrir_email_dans_navigateur' target='_blank' class='AViewBrowser'></a>").appendTo($Td).text(option.bddCtrl.paraAppli.mGetPara("mailing_text_lien_vue_browser"))

        $("<!-- FIN LIEN AFFICHAGE NAVIGATEUR -->").appendTo(option.element)
    }

    this.nom = "Afficher navigateur"
    this.icone = "fas fa-arrow-up-right-from-square"

    function mGetLink() { return $(option.element.find("a")[0]) }

    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()

        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Texte du lien:</td>").appendTo(contentElement)
        contentElement.closest(".dx-item-content").css("overflow", "visible")
        $("<div/>").appendTo(contentElement).dxCtrlTxtEmoji({
            bddCtrl: option.bddCtrl,
            pickerPosition: "bottom",
            value: mGetLink().text(),
            placeholder: "Texte du lien d'affichage dans le navigateur...",
            onValueChanged: function (value) {
                mGetLink().text(value)
            },
            onLoad: function () {
            }
        }).dxCtrlTxtEmoji("instance")
    }

    this.mAddCtrlStyle = function (contentElement) {
        contentElement.empty()

        var jsonCssDataOriginalValue = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        var jsonCssData = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("lienouvrirnavigateur")) {
            jsonCssData[prop] = ""
            if (typeof jsonCssDataOriginalValue[prop] != 'undefined') jsonCssData[prop] = jsonCssDataOriginalValue[prop]
        }
        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Style du texte:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleFont({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            value: jsonCssData,
            showAlign: false,
            allowDefaut: true,
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    if (value.value.length > 0) { jsonCssDataOriginalValue[value.prop] = value.value }
                    else { delete jsonCssDataOriginalValue[value.prop] }
                })
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })
    }

    this.mRemoveStyle = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("lienouvrirnavigateur")) {
            delete jsonCssData[prop]
        }
        option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssData))
        option.onValueChanged()
    }

    this.mUpdateCss = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("lienouvrirnavigateur")) {
            var ele = option.parent.mGetBodyWidget()
            switch (prop) {
                case "color": case "font-weight": case "font-style": case "text-decoration": case "line-height": case "letter-spacing": case "font-family": case "font-size":
                    ele = mGetLink()
                    break;
            }
            if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                ele.css(prop, jsonCssData[prop])
            } else {
                ele.css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("lienouvrirnavigateur", prop))
            }
        }
    }

}